import { useQuery } from '@tanstack/react-query';
import { useAccountApi } from '../../hooks/use-settings-api';

export const QK_CONFIRMED_PASSWORD_STATUS = ['confirmed-password-status'] as const;

export function useConfirmedPasswordStatus() {
  const { accountApi } = useAccountApi();

  return useQuery({
    queryKey: QK_CONFIRMED_PASSWORD_STATUS,
    queryFn: () => accountApi.confirmedPasswordStatus(),
    // Whether the password is confirmed is session-scoped security state, not app data - it must
    // not survive past this component unmounting (e.g. a logout/login in the same tab), or a
    // stale `confirmed: true` from the old session lets `usePasswordConfirmationGuard` skip
    // re-prompting for the password entirely.
    gcTime: 0,
  });
}
